import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

import { checkQuote } from '../util/check-quote.js';

/**
 * @param {Definition} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
export function definition(node, _, state, info) {
  const quote = checkQuote(state);
  const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
  const exit = state.enter('definition');
  let subexit = state.enter('label');
  const tracker = state.createTracker(info);
  let value = tracker.move('[');
  value += tracker.move(state.safe(state.associationId(node), _objectSpread({
    before: value,
    after: ']'
  }, tracker.current())));
  value += tracker.move(']: ');
  subexit();
  if (
  // If there’s no url, or…
  !node.url ||
  // If there are control characters or whitespace.
  /[\0- \u007F]/.test(node.url)) {
    subexit = state.enter('destinationLiteral');
    value += tracker.move('<');
    value += tracker.move(state.safe(node.url, _objectSpread({
      before: value,
      after: '>'
    }, tracker.current())));
    value += tracker.move('>');
  } else {
    // No whitespace, raw is prettier.
    subexit = state.enter('destinationRaw');
    value += tracker.move(state.safe(node.url, _objectSpread({
      before: value,
      after: node.title ? ' ' : '\n'
    }, tracker.current())));
  }
  subexit();
  if (node.title) {
    subexit = state.enter("title".concat(suffix));
    value += tracker.move(' ' + quote);
    value += tracker.move(state.safe(node.title, _objectSpread({
      before: value,
      after: quote
    }, tracker.current())));
    value += tracker.move(quote);
    subexit();
  }
  exit();
  return value;
}